var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.931.969C3.185.969.15 4.03.15 7.75a6.78 6.78 0 0 0 6.781 6.781c3.719 0 6.781-3.035 6.781-6.781 0-3.719-3.062-6.781-6.78-6.781zm0 1.312c3.008 0 5.469 2.461 5.469 5.469a5.467 5.467 0 0 1-5.469 5.469A5.45 5.45 0 0 1 1.462 7.75a5.467 5.467 0 0 1 5.47-5.469zm3.828 3.582-.629-.629c-.109-.136-.328-.136-.464 0L5.81 9.063 4.17 7.421a.315.315 0 0 0-.465 0l-.63.601c-.109.137-.109.356 0 .465l2.489 2.516a.315.315 0 0 0 .465 0l4.73-4.676c.11-.137.11-.355 0-.465z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFilter);
export default __webpack_public_path__ + "static/media/status-filter.d3fd8ef72c2e2466d3656c26593f7388.svg";
export { ForwardRef as ReactComponent };